/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_Template_DefaultInputs */

const cs_property_legal_template_default = /** @type {(inputs: Property_Legal_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednoduchá nájemní smlouva`)
};

const en_property_legal_template_default = /** @type {(inputs: Property_Legal_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple lease`)
};

/**
* | output |
* | --- |
* | "Simple lease" |
*
* @param {Property_Legal_Template_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_template_default = /** @type {((inputs?: Property_Legal_Template_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_Template_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_template_default(inputs)
	return cs_property_legal_template_default(inputs)
});